import React, { Component } from 'react';
import DatePickerExpiration from './DatePickerExpiration.jsx';

class CheckUpdateValue extends Component {
    constructor(props) {
        super(props);
        this.changeCheck = this.changeCheck.bind(this);
    }

    changeCheck(event) {
        this.props.changeCheck(event.target.id, event.target.checked)
    }

    render () {
        let updateInput = null;
        if (this.props.data.CheckUpdateValue) {
            updateInput = <DatePickerExpiration data={this.props.data}
                changeDate={this.props.changeDate}
                changeDataError={this.props.changeDataError}/>
        }

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <ul className="no-bullets no-padding no-margin">
                                <li className="inlineListItem2 lg-margin">
                                   <div className="default-checkbox">
                                        <input type="checkbox" id="chkActualizarValorAlRenovar" checked={this.props.data.CheckUpdateValue} onClick={this.changeCheck} /> 
                                        <label className="label-primary" htmlFor="chkActualizarValorAlRenovar"></label>
                                    </div>
                                </li>
                                <li className="inlineListItem2">
                                    <label className="label-primary" htmlFor="chkActualizarValorAlRenovar">Actualizar el valor al renovar</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {updateInput}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {this.props.data.ERROR_EMPRESA["seleccionoFechaRenovacion"] == false ? <label className="error">Debe seleccionar una fecha válida y/o posterior al dia de la fecha.</label>
                                : this.props.data.dataPickerError ? <label className="error">Debe seleccionar una fecha válida y/o posterior al dia de la fecha.</label>
                                    : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default CheckUpdateValue;